const testimonials = [
  {
    name: "Daniel Tap",
    credit: "Founder & CEO, OnlineWithYou, NL",
    testimonial:
      "Arif is a hard-working and trustworthy web developer from Bangladesh. He is always eager to take on new projects and learn new skills where necessary. What stands out in collaborating with him is his adeptness at converting innovative concepts into operational applications.",
    client_img: require("@/assets/images/testimonials/daniel_tap_onlinewithyou.webp"),
    color: "#33FFFF",
  },

  {
    name: "Lisa Henton",
    credit: "Business Owner, UK",
    testimonial: `Arif is very attentive to my requirements, gave advice and guidance. Very easy to work with and did a great job on my website. Very fast delivery and quality was 100% Would highly recommend thank you for creating a fab site, we will be back `,
    client_img: require("@/assets/images/testimonials/jaffacat13.webp"),
    color: "#b7b9b8",
  },

  {
    name: "Mahmudul Hasan",
    credit: "Software Engineer, Apptriangle Limited",
    testimonial:
      "Arif Islam is an exceptional developer with a versatile skill set spanning WordPress, Laravel, Vue, and React. His standout quality lies in his remarkable ability to swiftly grasp new concepts, making him an invaluable asset to any team. Arif's dedication to learning and staying ahead of the curve sets him apart, making him a truly talented and reliable professional in the world of development.",
    client_img: require("@/assets/images/testimonials/mahmudul-hasan.webp"),
    color: "#0808d7",
  },

  {
    name: "Andy S.",
    credit: "Business Owner, UAE",
    testimonial:
      "Arif is an excellent person and takes his work very seriously, communication was always friendly. Overall he was willing and enthusiatic and gave his all.",
    client_img: require("@/assets/images/testimonials/andys.jpg"),
    color: "#6ac4c5",
  },
  {
    name: "Azizul H.",
    credit: "Founder & CEO of getwpexpert.com",
    testimonial:
      "Arif is an exceptional web developer with a knack for mastering various framework. His dedication to detail and pursuit of excellence is impressive. He simplifies complex tech ideas, making him a great mentor and team player.",
    client_img: require("@/assets/images/testimonials/md-azizul-haque.jpg"),
    color: "#89b1bb",
  },
  {
    name: "Motahar A.",
    credit: "Sub-Divisional Engineer, RHD",
    testimonial:
      "Arif Islam is a remarkable developer, known for his proficiency in multiple programming languages and frameworks. His problem-solving skills and attention to detail make him an invaluable asset to any person",
    client_img: require("@/assets/images/testimonials/motahar-ali.jpeg"),
    color: "#71008b",
  },
];

export default testimonials;
